import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import WithdrawalComponent from '../components/WithdrawalComponent';
import DepositComponent from '../components/DepositComponent';
import DepositAndWithdrawal from '../components/DepositAndWithdrawalComponent';
import actions from '../redux/actions/transactions';
import whiteListAction from '../redux/actions/white_list';

const mapStateToProps = (state) => ({
  coins: state.setting.coins,
  balances: state.user.userBalances,
  trans: state.trans,
  settings: state.setting.coinSettings,
  info: state.user.info,
  limits: state.setting.limitWithdrawals,
  currencyMarkets: state.setting.currencyMarkets,
});

const mapDispatchToProps = (dispatch) => ({
  onWithdrawal: (params, callback) => {
    dispatch(actions.onWithdrawal(params, callback));
  },
  onFetchTransactionHistory: (params) => {
    dispatch(actions.onFetchTransactionHistory(params));
  },
  onSaveAddressAction: (params) => {
    dispatch(whiteListAction.onSaveAddressAction(params));
  },
  fetchUserVolume24hAction: (params, forceFetch = false) => {
    dispatch(actions.fetchUserVolume24hAction(params, forceFetch));
  },
  onWithdrawalCustomCoin: (params, callback) => {
    dispatch(actions.onWithdrawalCustom(params, callback));
  },
});

export const WithdrawalContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(WithdrawalComponent));
export const DepositContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(DepositComponent));
export const DepositAndWithdrawalContainer = connect(mapStateToProps, mapDispatchToProps)(DepositAndWithdrawal);
